import LashbrookLogo from '../assets/images/lashbrook.svg';
// import HelzbergLogo from '../assets/images/helzberg.svg';
// import HelzbergLogoPink from '../assets/images/helzberg-pink.svg';
import HelzbergLogo from '../assets/images/helzberg2.svg';
import HelzbergLogo2 from '../assets/images/helzberg-black.svg';
import { matchPath } from 'react-router-dom';
import { IParams } from '../components/RingCustomizerHOC';
import { IOption } from '../types/customizer';

import weddingBand from '../assets/images/wedding-bands.png';
import anniversary from '../assets/images/anniversary.png';
import signet from '../assets/images/signet.png';
import collegiateSignets from '../assets/images/collegiate-signets.png';
import collegiateBand from '../assets/images/collegiate-band.png';
import collegiateSleeve from '../assets/images/collegiate-sleeve.png';

//all client names in Lowercase
export const CLIENTS = ['helzberg'];

export const isEmpty = (value: any) =>
  value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);

export type AnyObject = { [key: string]: any };

export const lowercaseKeys = (obj: AnyObject, deep = true) =>
  Object.keys(obj).reduce((acc, key) => {
    const convertedKey = key.replace(/\s+/g, '_').toLowerCase();
    acc[convertedKey] = deep && typeof obj[key] === 'object' ? lowercaseKeys(obj[key]) : obj[key];
    return acc;
  }, {} as AnyObject);

export const defaultRingUrls = {
  band: '/rings/profiles/D/widths/7/ring_materials/14KW?ring_finish=SATIN&finish_type=F&weight=P&size=10&feature_group=N&sleeve=NONE',
  womens:
    '/women/rings/styles/010/ring_materials/14KW/color_arrangements/B/stone_quantities/HALFETERNITY/variants/2?size=7&dia=LABDIA-ST',
  collegiate_signet:
    '/rings/collegiate_signet/ring_materials/14KY?ring_finish=POLISH,POLISH,&shape=CIRC&size=SM&shank=T&school=BYU&signet_engraving=BYU2&cerakote_color=NONE&finger_size=10&weight=S',
  signet:
    '/rings/signet/ring_materials/14KW?ring_finish=POLISH,POLISH,&shape=CIRC&size=SM&shank=T&finger_size=10&feature_group=N&weight=S'
};

export const getCategorizedOptions = (sku: string, storeData: AnyObject | null) => {
  const { show_women_builder, show_signet_builder, show_collegiate_builder } = storeData || {};

  const list: IOption[] = [];
  list.push({
    name: 'Band',
    type: 'option',
    swatch_url: weddingBand,
    selected: false,
    sku: 'band'
  });
  if (show_women_builder) {
    list.push({
      name: 'Anniversary',
      type: 'option',
      swatch_url: anniversary,
      selected: false,
      sku: 'womens'
    });
  }
  if (show_signet_builder) {
    list.push({
      name: 'Signet',
      type: 'option',
      sku: 'signet',
      swatch_url: signet,
      selected: false
    });
  }
  if (show_collegiate_builder) {
    list.push({
      name: 'Collegiate',
      type: 'option',
      swatch_url: collegiateSignets,
      selected: false,
      sku: 'collegiate_signet'
    });
  }
  return list.map((item) => {
    if (item.sku === sku) {
      item.selected = true;
    }
    return item;
  });
};

export const getTypeOptions = (sku: string) => {
  if (sku === 'signet') {
    return [];
  } else {
    const list: IOption[] = [
      {
        name: 'Collegiate Signet',
        type: 'option',
        swatch_url: collegiateSignets,
        selected: false,
        sku: 'collegiate_signet'
      }
      // {
      //   name: 'Collegiate Band',
      //   type: 'option',
      //   swatch_url: collegiateBand,
      //   selected: false,
      //   sku: 'collegiate_band',
      // },
      // {
      //   name: 'Collegiate Sleeve',
      //   type: 'option',
      //   swatch_url: collegiateSleeve,
      //   selected: false,
      //   sku: 'collegiate_sleeve',
      // },
    ];
    return list.map((item) => {
      if (item.sku === sku) {
        item.selected = true;
      }
      return item;
    });
  }
};

export const DEFAULT_STYLES = {
  brandlogo: `url(${LashbrookLogo})`,
  brandlogoSecondary: `url(${LashbrookLogo})`,
  brandColor: '#2a77a7',
  primaryBgColor: '#f2f5f7',
  secondaryBgColor: '#ffffff',
  primaryColor: '#003053',
  secondaryColor: '#323232',
  tertiaryColor: '#ffffff',
  primaryFont: 'Reckless',
  secondaryFont: 'Neue Haas Unica Pro',
  primaryBorderColor: '#DDCC7C',
  secondaryBorderColor: '#e9ecef',
  primaryBorderRadius: '8px',
  secondaryBorderRadius: '4px',
  tertiaryBorderRadius: '9999px',
  rcBoxTabCase: 'capitalize',
  sidebarOrder: '0'
};

export const APP_STYLES: { [key: string]: typeof DEFAULT_STYLES } = {
  helzberg: {
    ...DEFAULT_STYLES,
    brandlogo: `url(${HelzbergLogo})`,
    brandlogoSecondary: `url(${HelzbergLogo2})`,
    brandColor: '#1C1A1A',
    primaryBgColor: '#FFFFFF',
    secondaryBgColor: '#FFFFFF',
    primaryColor: '#1C1A1A',
    secondaryColor: '#909090',
    tertiaryColor: '#FFFFFF',
    primaryFont: 'Avenir Next LT Pro',
    secondaryFont: 'Avenir Next LT Pro',
    primaryBorderColor: '#ABC2D6',
    secondaryBorderColor: '#ABC2D6',
    primaryBorderRadius: '0',
    secondaryBorderRadius: '0',
    tertiaryBorderRadius: '0',
    rcBoxTabCase: 'uppercase',
    sidebarOrder: '1'
  }
};

export const isRightSidebar = (pathPrefix: string) => {
  const rightSidebarClients = ['helzberg'];

  return rightSidebarClients.includes(pathPrefix);
};

export const isDoneAtBottom = (pathPrefix: string) => {
  const clients = ['helzberg'];

  return clients.includes(pathPrefix);
};

export const shouldHideSKU = (pathPrefix: string = '') => {
  const hiddenSKUclients = ['helzberg'];

  return hiddenSKUclients.includes(pathPrefix);
};

export const urlToParams = (ring_url: string) => {
  const [pathString, queryString] = ring_url ? ring_url.split('?') : [];
  const matchObj = matchPath(pathString, {
    path: [
      '/rings/profiles/:profile/widths/:width/ring_materials/:ring_materials',
      '/:pathPrefix/rings/profiles/:profile/widths/:width/ring_materials/:ring_materials',
      '/women/rings/styles/:styles/ring_materials/:ring_materials/color_arrangements/:color_arrangements/stone_quantities/:stone_quantities/variants/:variants',
      '/:pathPrefix/women/rings/styles/:styles/ring_materials/:ring_materials/color_arrangements/:color_arrangements/stone_quantities/:stone_quantities/variants/:variants',
      '/rings/:ring_type/ring_materials/:ring_materials',
      '/:pathPrefix/rings/:ring_type/ring_materials/:ring_materials'
    ],
    exact: true
  });

  const searchParams = new URLSearchParams(queryString);
  const queryParams: IParams['queryParams'] = Object.fromEntries(searchParams.entries());
  const pathParams: IParams['pathParams'] = matchObj?.params || {};
  return { pathParams, queryParams };
};
